/**
* GENERATED BY RPC GEN - LESS MODIFY BY HAND
* thirdauth-service.ts  2024-05-22T11:45:33+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'bt-rpc-base';

import type { MobToken, AccessToken, WxBind, WxLogin } from './auth-dto';

const _ = 'ThirdAuth/';

export class ThirdAuthService {

  constructor(readonly r: RpcService) {}
  // Mob/一键注册&登录
  mobLogin(d:MobToken, m?: M): R<AccessToken>{
    return this.r.async(_ + 'mobLogin', d, m);
  }
  // 公众号登录，同时绑定手机号
  wxBind(d:WxBind, m?: M): R<AccessToken>{
    return this.r.async(_ + 'wxBind', d, m);
  }
  // 公众号登录
  wxLogin(d:WxLogin, m?: M): R<AccessToken>{
    return this.r.async(_ + 'wxLogin', d, m);
  }
}
